import * as Mutations from './mutations';

export const SpinnerModule = {
    state: {
        isLoading: false,
        showProgress: false
    },

    mutations: {
        [Mutations.SET_LOADING] (state) {
            state.isLoading = true;
        },

        [Mutations.SET_LOADED] (state) {
            state.isLoading = false;
        },

        [Mutations.SHOW_PROGRESS] (state) {
            state.showProgress = true;
        },

        [Mutations.HIDE_PROGRESS] (state) {
            state.showProgress = false;
        }
    },

    actions: {
        showSpinner(context) {
            context.commit(Mutations.SET_LOADING);
        },

        hideSpinner(context) {
            setTimeout(() => {
                context.commit(Mutations.SET_LOADED);
            });
        },

        showProgress(context) {
            context.commit(Mutations.SHOW_PROGRESS);
        },

        hideProgress(context) {
            context.commit(Mutations.HIDE_PROGRESS);
        }
    },

    getters: {
        isLoading: state => state.isLoading,

        showProgress: state => state.showProgress
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/spinner/spinner.module.js